import React from 'react'

class SplitRate extends React.Component {
  render() {
    const {
      repaymentWithFrequency,
      fixedRateLabel,
      fixedAmountLabel,
      variableRateLabel,
      variableAmountLabel,
    } = this.props

    return(
      <div>
        <p>
          You will repay <strong>{ repaymentWithFrequency }</strong> at:
        </p>
        <ul className='pl-4'>
          <li>a <strong>fixed rate</strong> of <strong>{ fixedRateLabel }</strong> for { fixedAmountLabel }</li>
          <li>a <strong> variable rate</strong> of <strong>{ variableRateLabel }</strong> for { variableAmountLabel }</li>
        </ul>
      </div>
    )
  }
}

export default SplitRate
